import React, { useState } from 'react';

import { type DispatcherInstructionsForm } from './dispatcher_instruction_form';
import { DispatcherInstructionsDialog } from './dispatcher_instructions_dialog';

export const DispatcherInstructionsButton: React.FC<{
  form: DispatcherInstructionsForm;
  onSave(_: DispatcherInstructionsForm): void;
}> = ({ form, onSave }) => {
  const [open, setOpen] = useState(false);

  const instructions =
    !!form.mover_notes || !!form.warehouse_notes || (form.addons && form.addons.length > 0) || !!form.load_out;

  const onOpen = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <a
        href="#"
        className="btn-link text-bold"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onOpen();
        }}
      >
        {instructions ? 'Edit Materials/Instructions' : 'Add Materials/Instructions'}
      </a>
      {open && (
        <DispatcherInstructionsDialog
          form={form}
          onClose={onClose}
          onSave={(form) => {
            onSave(form);
            onClose();
          }}
        />
      )}
    </>
  );
};
